class SearchBar extends HTMLElement {
    constructor() {
        super();

        this.searchBarOverlay = document.querySelector('[data-search-overlay]');
        this.searchTriggerIcon = document.querySelector('[data-search-icon]');
        this.searchTriggerIconMobile = document.querySelector('[data-search-icon-mobile]');
        this.overlay = document.getElementById('page-blur-overlay');
        this.searchCloseBtn = this.querySelector('[data-search-modal-close]');
        this.searchClearBtn = this.querySelector('[data-search-clear]');
    }

    connectedCallback() {
        this.header = document.querySelector('.header');
        if (!this.header) return;
        this.enjpHeader = document.querySelectorAll('.tw-enjp-header');
        if (!this.enjpHeader) return;


        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);


        [this.searchTriggerIcon, this.searchTriggerIconMobile, this.searchCloseBtn, this.searchBarOverlay].forEach(btn => {
            if (btn) {
                btn.addEventListener('click', e => this.toggleSearch(e));
            }
        });

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeSearch(evt));

        subscribe(PUB_SUB_EVENTS.onOpenMenu, (msg, data) => {
            this.closeSearch();
        });

    }

    toggleSearch(e){
        e.preventDefault();
        //this.searchClearBtn.click();
        this.classList.toggle('open');
        this.enjpHeader?.forEach(el => {
            el.classList.toggle('search-open');
        });
        this.searchBarOverlay?.classList.toggle('tw-hidden');

        publish(PUB_SUB_EVENTS.onToggleSearch, {
            isOpen: this.classList.contains('open')
        });
        if (this.classList.contains('open')){
            document.body.classList.add('tw-overflow-hidden');
        }
        else{
            document.body.classList.remove('tw-overflow-hidden');
        }

    }

    closeSearch(e){
        e?.preventDefault();
        //this.searchClearBtn.click();
        this.classList.remove('open');
        this.enjpHeader?.forEach(el => {
            el.classList.remove('search-open');
        });
        this.searchBarOverlay?.classList.add('tw-hidden');

    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }
}
if (!customElements.get('search-bar')) {
    customElements.define('search-bar', SearchBar);
}